/* eslint-disable */

import React from "react";
import styles from "./CheckoutAdditionalInfo.scss";
import { defineMessages, FormattedMessage, FormattedNumber } from "react-intl";
import classnames from "classnames";
import { Thumbnail, MapView, CancellationMessage, PendingAmountInfo } from "~/components";
import { buildImgUrl, renderHTML } from "../../utils/misc";
import { withState } from "recompose";
import constants from "../../utils/constants";
import MasterCard from "../../theme/payments/MasterCard.png";

const msgs = defineMessages({
  totalTaxes: {
    id: "checkout.additional_info.totalTaxes",
    description: "Total taxes included",
    defaultMessage: "Total taxes included",
  },
  payNow: {
    id: "checkout.additional_info.payNow",
    description: "Pay now",
    defaultMessage: "Pay now",
  },
  payProperty: {
    id: "checkout.additional_info.payAtProperty",
    description: "Pay at the property",
    defaultMessage: "Pay at the property",
  },
  informativeMsg: {
    id: "checkout.additional_info.informativeMsg",
    description: "Informs about payment occurs in default currency of hotel",
    defaultMessage: "Merely informative. Payments in",
  },
  cancelUntil: {
    id: "checkout.additional_info.cancelUntil",
    description: "Text for max date to cancel",
    defaultMessage: "Can be cancelled online until",
  },
  readConditions: {
    id: "checkout.additional_info.readConditions",
    description: "Read conditions",
    defaultMessage: "read conditions and cancellation policy",
  },
  noDeposit: {
    id: "checkout.additional_info.noDeposit",
    description: "No deposit required",
    defaultMessage: "No deposit required",
  },
  viewMap: {
    id: "checkout.additional_info.viewMap",
    description: "View map",
    defaultMessage: "view map",
  },
  addAnother: {
    id: "checkout.addAnother",
    description: "addAnother",
    defaultMessage: "Add another reservation",
  },
  shareBookingCart: {
    id: "app.share_booking.share_booking_cart",
    description: "Share booking cart",
    defaultMessage: "Share booking cart",
  },
});

function getImagePath(creditCard) {
  switch (creditCard) {
    case constants.CREDIT_CARDS.AmericanExpress:
    case constants.CREDIT_CARDS.Diners:
    case constants.CREDIT_CARDS.Discover:
    case constants.CREDIT_CARDS.Jcb:
    case constants.CREDIT_CARDS.MasterCard:
    case constants.CREDIT_CARDS.Visa:
    case constants.CREDIT_CARDS.PCI:
    case constants.CREDIT_CARDS.COMODO_SECURE:
    case constants.CREDIT_CARDS.UnionPay:
      return require(`../../theme/payments/${creditCard}.png`);

    default:
      return null;
  }
}

function CheckoutAdditionalInfo({
  media,
  pendingTotal,
  bookingTotalRate,
  depositTotal,
  bookingOriginalRate,
  depositOriginalRate,
  pendingOriginal,
  currency,
  handleGallery,
  setInnerState,
  defaultCurrency,
  handleModalContent,
  propertyContact,
  propertyName,
  creditCardTypes,
  className,
  cancelableUntilList,
  handleConditions,
  pendingAmountTextConfiguration,
  handleAddReservation,
  handleShareBookingCart,
  hideControls,
  iframeMode,
}) {
  const openGallery = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (media) {
      try {
        handleGallery(media.toJS(), propertyName, propertyContact.get("description"), {
          bgOpacity: 0.85,
          index: 0,
          preload: [1, 1],
        });
      } catch (exc) {
        console.error(exc);
      }
    }
  };
  const getMapViewCenter = () => {
    if (propertyContact) {
      return {
        lat: propertyContact.get("latitude"),
        lng: propertyContact.get("longitude"),
      };
    }
    return {
      lat: -25.363882,
      lng: 131.044922,
    };
  };
  const getMapMarker = () => {
    if (propertyContact) {
      return [
        {
          type: "marker",
          position: new google.maps.LatLng(
            propertyContact.get("latitude"),
            propertyContact.get("longitude")
          ), // eslint-disable-line
        },
      ];
    }
  };
  const generateMapView = () => {
    return <MapView initialMarkers={getMapMarker()} initialCenter={getMapViewCenter()} />;
  };
  const handleModal = () => {
    handleModalContent(generateMapView(), { mobileMode: true, className: "wbkv9-Modal-mapModal" });
  };
  const hasThumbnail = media && media.first() && media.first().get("url");

  let mediaWidth = 1920;
  let mediaHeight = 1080;
  if (window.innerWidth < 768) {
    mediaWidth = 750;
    mediaHeight = 500;
  }

  return (
    <div className={classnames("wbkv9-CheckoutAdditionalInfo", styles.mainContainer)}>
      <div
        className={classnames(
          "wbkv9-CheckoutAdditionalInfo-container",
          styles.container,
          styles[className],
          "checkoutAdditionalInfo",
          iframeMode && styles.iframeMode
        )}>
        <div className={classnames("wbkv9-CheckoutAdditionalInfo-leftColumn", styles.leftColumn)}>
          {!hideControls && (
            <div
              className={classnames(
                "wbkv9-CheckoutAdditionalInfo-leftColumn-controls",
                styles.leftColumnControls
              )}>
              <div
                className={classnames(
                  "wbkv9-CheckoutAdditionalInfo-leftColumn-controls",
                  styles.control
                )}
                onClick={handleAddReservation}>
                <FormattedMessage {...msgs.addAnother} />
              </div>
              <div
                className={classnames(
                  "wbkv9-CheckoutAdditionalInfo-leftColumn-controls",
                  styles.control
                )}
                onClick={handleShareBookingCart}>
                <FormattedMessage {...msgs.shareBookingCart} />
              </div>
            </div>
          )}
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-hotelInfo",
              styles.wrapper,
              "hotelInfo",
              styles.desktop,
              "wrapper"
            )}>
            <div className={classnames(styles.leftContainer, "leftContainer")}>
              <div className="title">{propertyName}</div>
              <div className="address">
                <div className={classnames(styles.text, "text")}>
                  {propertyContact.get("address")}
                </div>
                <div className={classnames(styles.text, "text")}>{propertyContact.get("city")}</div>
                <div className={classnames(styles.text, "text")}>
                  {propertyContact.get("country")}
                </div>
                <a className="link" onClick={handleModal}>
                  <FormattedMessage {...msgs.viewMap} />
                </a>
              </div>
              <div className={classnames(styles.text, "phone")}>{propertyContact.get("phone")}</div>
            </div>
            <div className={styles.rightContainer}>
              {hasThumbnail && (
                <div className={styles.thumbnailContainer} onClick={openGallery}>
                  <Thumbnail
                    src={
                      media &&
                      media.first() &&
                      buildImgUrl(media.first().get("url"), 105, 170, false)
                    }
                    onHover={value => setInnerState(val => ({ ...val, isThumbnailOnHover: value }))}
                    icon
                    title={media && media.first() && media.first().get("title")}
                  />
                </div>
              )}
            </div>
          </div>
          {currency !== defaultCurrency && (
            <div>
              <div className={classnames("wbkv9-CheckoutAdditionalInfo-totalTaxes", "totalTaxes")}>
                <div className={classnames("wbkv9-CheckoutAdditionalInfo-title", styles.title)}>
                  <FormattedMessage {...msgs.totalTaxes} /> ({currency}*)
                </div>
                <div className={classnames("wbkv9-CheckoutAdditionalInfo-title", styles.title)}>
                  <FormattedNumber
                    value={bookingTotalRate}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                </div>
              </div>

              <div
                className={classnames(
                  "wbkv9-CheckoutAdditionalInfo-totalTaxes",
                  styles.wrapper,
                  "totalTaxes"
                )}>
                <div className={styles.leftContainer}>
                  {typeof depositTotal !== "undefined" &&
                    depositTotal !== null &&
                    depositTotal > 0 && (
                      <div>
                        <FormattedMessage {...msgs.payNow} /> (
                        <FormattedNumber value={depositTotal / bookingTotalRate} style="percent" />)
                      </div>
                    )}
                  {(typeof depositTotal === "undefined" ||
                    depositTotal === null ||
                    depositTotal <= 0) && (
                    <div className={styles.noDeposit}>
                      <FormattedMessage {...msgs.noDeposit} />
                    </div>
                  )}
                  <div>
                    <FormattedMessage {...msgs.payProperty} /> (
                    <FormattedNumber value={pendingTotal / bookingTotalRate} style="percent" />)
                  </div>
                </div>
                <div className={styles.rightContainer}>
                  {typeof depositTotal !== "undefined" &&
                    depositTotal !== null &&
                    depositTotal > 0 && (
                      <div>
                        <FormattedNumber
                          value={depositTotal}
                          minimumFractionDigits={2}
                          maximumFractionDigits={2}
                        />
                      </div>
                    )}
                  {(typeof depositTotal === "undefined" ||
                    depositTotal === null ||
                    depositTotal <= 0) && (
                    <div>
                      <FormattedNumber
                        value={0}
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                      />
                    </div>
                  )}
                  <div>
                    <FormattedNumber
                      value={pendingTotal}
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />
                  </div>
                </div>
              </div>
              <div
                className={classnames(
                  "wbkv9-CheckoutAdditionalInfo-informativeMsg",
                  "informativeMsg"
                )}>
                <span>
                  * <FormattedMessage {...msgs.informativeMsg} /> {defaultCurrency}
                </span>
              </div>
            </div>
          )}
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-totalTaxesDefault",
              "totalTaxesDefault"
            )}>
            <div className={classnames("wbkv9-CheckoutAdditionalInfo-title", styles.title)}>
              <FormattedMessage {...msgs.totalTaxes} /> ({defaultCurrency})
            </div>
            <div className={classnames("wbkv9-CheckoutAdditionalInfo-title", styles.title)}>
              <FormattedNumber
                value={bookingOriginalRate}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
            </div>
          </div>

          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-totalTaxesDefault",
              styles.wrapper,
              "totalTaxesDefault"
            )}>
            <div className={styles.leftContainer}>
              {typeof depositOriginalRate !== "undefined" &&
                depositOriginalRate !== null &&
                depositOriginalRate > 0 && (
                  <div>
                    <FormattedMessage {...msgs.payNow} /> (
                    <FormattedNumber
                      value={depositOriginalRate / bookingOriginalRate}
                      style="percent"
                    />
                    )
                  </div>
                )}
              {(typeof depositOriginalRate === "undefined" ||
                depositOriginalRate === null ||
                depositOriginalRate <= 0) && (
                <div className={styles.noDeposit}>
                  <FormattedMessage {...msgs.noDeposit} />
                </div>
              )}
              <PendingAmountInfo
                section={constants.PENDING_AMOUNT_INFO_SECTION.TEXT}
                pendingAmountTextConfiguration={pendingAmountTextConfiguration}
                percentage={pendingOriginal / bookingOriginalRate}
                pendingAmount={pendingOriginal}
              />
            </div>
            <div className={styles.rightContainer}>
              {typeof depositOriginalRate !== "undefined" &&
                depositOriginalRate !== null &&
                depositOriginalRate > 0 && (
                  <div>
                    <FormattedNumber
                      value={depositOriginalRate}
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />
                  </div>
                )}
              {(typeof depositOriginalRate === "undefined" ||
                depositOriginalRate === null ||
                depositOriginalRate <= 0) && (
                <div>
                  <FormattedNumber value={0} minimumFractionDigits={2} maximumFractionDigits={2} />
                </div>
              )}
              <PendingAmountInfo
                section={constants.PENDING_AMOUNT_INFO_SECTION.AMOUNT}
                pendingAmount={pendingOriginal}
                pendingAmountTextConfiguration={pendingAmountTextConfiguration}
              />
            </div>
          </div>
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-conditions",
              styles.wrapper,
              "conditions"
            )}>
            <div className={styles.cancelUntil}>
              <span className={styles.cancelableDates}>
                {!!cancelableUntilList &&
                  cancelableUntilList.map(({ startDate, cancelRelease }, idx) => (
                    <div key={idx}>
                      <CancellationMessage
                        mode={"SHORT"}
                        className={styles.cancellationMessage}
                        cancellationRelease={cancelRelease}
                        reservationStartDate={startDate}
                      />
                    </div>
                  ))}
              </span>
            </div>
            <div className="readConditions">
              <a className="link" onClick={handleConditions}>
                <FormattedMessage {...msgs.readConditions} />
              </a>
            </div>
          </div>
        </div>
        <div className={classnames("wbkv9-CheckoutAdditionalInfo-rightColumn", styles.rightColumn)}>
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-hotelInfo",
              styles.wrapper,
              "hotelInfo",
              styles.mobile
            )}>
            <div
              className={classnames(
                "wbkv9-CheckoutAdditionalInfo-leftContainer",
                styles.leftContainer,
                "leftContainer"
              )}>
              <div className="title">{propertyName}</div>
              <div className="address">
                <div className={styles.text}>{propertyContact.get("address")}</div>
                <div className={styles.text}>{propertyContact.get("city")}</div>
                <div className={styles.text}>{propertyContact.get("country")}</div>
                <a className="link" onClick={handleModal}>
                  <FormattedMessage {...msgs.viewMap} />
                </a>
              </div>
              <div className={classnames(styles.text, "phone")}>{propertyContact.get("phone")}</div>
            </div>
            <div className={styles.rightContainer}>
              {hasThumbnail && (
                <div className={styles.thumbnailContainer} onClick={openGallery}>
                  <Thumbnail
                    src={
                      media &&
                      media.first() &&
                      buildImgUrl(media.first().get("url"), 105, 170, false)
                    }
                    onHover={value => setInnerState(val => ({ ...val, isThumbnailOnHover: value }))}
                    icon
                    title={media && media.first() && media.first().get("title")}
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-paymentsContainer",
              styles.wrapper,
              styles.paymentsContainer
            )}>
            <div className={styles.payments}>
              <img src={getImagePath(constants.CREDIT_CARDS.COMODO_SECURE)} />

              {creditCardTypes.map((creditCard, idx) => {
                const imagePath = getImagePath(creditCard);
                if (imagePath) {
                  return <img src={imagePath} key={idx} />;
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={classnames(
          "wbkv9-CheckoutAdditionalInfo-fullWidthCheckoutSidebar",
          "fullWidthCheckoutSidebar",
          styles[className]
        )}>
        <div
          className={classnames(
            "wbkv9-CheckoutAdditionalInfo-checkoutEntityTitle",
            "checkoutEntityTitle"
          )}>
          {propertyName}
        </div>
        {hasThumbnail && (
          <div
            className={classnames(
              "wbkv9-CheckoutAdditionalInfo-thumbnailContainer",
              styles.thumbnailContainer
            )}
            onClick={openGallery}>
            <Thumbnail
              className="checkoutFullWidth"
              src={
                media &&
                media.first() &&
                buildImgUrl(media.first().get("url"), mediaHeight, mediaWidth, false)
              }
              onHover={value => setInnerState(val => ({ ...val, isThumbnailOnHover: value }))}
              icon
              title={media && media.first() && media.first().get("title")}
            />
          </div>
        )}
        <div className={classnames("wbkv9-CheckoutAdditionalInfo-description", "description")}>
          {<span dangerouslySetInnerHTML={renderHTML(propertyContact.get("description"))} />}
        </div>
      </div>
    </div>
  );
}

CheckoutAdditionalInfo.propTypes = {};

CheckoutAdditionalInfo.defaultProps = {};

const enhance = withState("innerState", "setInnerState", { isThumbnailOnHover: false });
export default enhance(CheckoutAdditionalInfo);
